exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-image, .view-existing {\n    font-weight: normal;\n}\n.remove-image, .view-existing a {\n    text-decoration: underline;\n    color: cornflowerblue;\n}\n", ""]);

// exports
